import React from "react";

// Admin Components
import AdminProtectedRoute from "../components/AdminProtectedRoute";
import AdminLogin from "../views/dashboard/admin/admin-login";
import AdminDashboard from "../views/dashboard/admin/admin-dashboard";
import AdminFacebookConnect from "../views/dashboard/admin/admin-facebook-connect";
import AdminFacebookCallback from "../views/dashboard/admin/admin-facebook-callback";

export const AdminRouter = [
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin/dashboard",
    element: (
      <AdminProtectedRoute>
        <AdminDashboard />
      </AdminProtectedRoute>
    ),
  },
  {
    path: "/admin/facebook-connect",
    element: (
      <AdminProtectedRoute>
        <AdminFacebookConnect />
      </AdminProtectedRoute>
    ),
  },
  {
    path: "/admin/facebook-callback",
    element: (
      <AdminProtectedRoute>
        <AdminFacebookCallback />
      </AdminProtectedRoute>
    ),
  },
];
